import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { DraggablePanelHeader } from "./draggable-panel-header";
import { DEFAULT_VALUES, setInitialPos } from "./helpers";
import classnames from "classnames";
import "./draggable-panel.scss";

export const DraggablePanel = ({ children, roleType, roleLabel, isQaEdit, ...props }) => {
    const isQA = roleType === "qa";
    const popoutRef = useRef();
    const qaOffset = isQaEdit ? 25 : 0;

    const panelStyle = {
        width: `${DEFAULT_VALUES[`coder_${roleType}`].width}px`,
    };

    useEffect(() => {
        let resizeObserverValue = popoutRef.current;
        setInitialPos(popoutRef, roleType);

        window.addEventListener("resize", handleResize);
        resizeObserver.observe(resizeObserverValue);

        return () => {
            resizeObserver.unobserve(resizeObserverValue);

            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleResize = (e) => {
        if (!popoutRef || !popoutRef.current) {
            return;
        }

        const wRect = DEFAULT_VALUES[`coder_${roleType}`];
        var tgtRect = popoutRef.current.getBoundingClientRect();
        var scrollBarWidth = window.innerWidth - document.body.clientWidth;

        var translateX = tgtRect.left;

        if (tgtRect.left + tgtRect.width > wRect.right) {
            translateX = document.body.clientWidth - tgtRect.width - scrollBarWidth;
        }

        popoutRef.current.style.transform = `translateX(${translateX - qaOffset}px)`;
    };

    const resizeObserver = new ResizeObserver(handleResize);
    const modalRoot = document.getElementById("modal-root");

    return createPortal(
        <>
            {isQaEdit && <div className="modal-overlay -transparent -under-panel"></div>}
            <div
                ref={popoutRef}
                className={classnames("popout-panel draggable", { "-extended-width": isQA })}
                style={panelStyle}
            >
                {!isQaEdit && (
                    <DraggablePanelHeader
                        togglePanel={props.togglePanel}
                        roleLabel={roleLabel}
                        roleType={roleType}
                        popoutRef={popoutRef}
                    />
                )}

                {children}
            </div>
        </>,
        modalRoot
    );
};
